module.exports = __webpack_public_path__ + "static/media/Apple iPad Silver.6802ef3e.png";